import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, align = "center" }) => {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-2xl ${alignClass}`}>
      <p
        className={`text-xs sm:text-sm font-body font-medium uppercase tracking-[0.35em] ${
          light ? "text-[#C9A24B]" : "text-[#9A7B2D]"
        }`}
      >
        {eyebrow}
      </p>
      <h2
        className={`mt-4 font-brand text-3xl sm:text-4xl tracking-wide ${
          light ? "text-[#F2EFE6]" : "text-[#383D33]"
        }`}
      >
        {title}
      </h2>
      <div className={`mt-5 flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        <span className="gold-hairline h-px w-16" />
        <span className="h-1.5 w-1.5 rotate-45 bg-[#C9A24B]" />
        <span className="gold-hairline h-px w-16" />
      </div>
      {subtitle && (
        <p
          className={`mt-5 font-body text-base leading-relaxed ${
            light ? "text-[#F2EFE6]/80" : "text-[#383D33]/80"
          }`}
        >
          {subtitle}
        </p>
      )}
    </Reveal>
  );
};
